// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddAddOnModal_addAddOnModal__zzHuA .AddAddOnModal_parentName__ZL1GT {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  margin: 0 0 12px 0;
}
.AddAddOnModal_addAddOnModal__zzHuA .AddAddOnModal_addOnList__N2-Xe {
  list-style: none;
  padding: 0;
  margin: 0 0 16px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.AddAddOnModal_addAddOnModal__zzHuA .AddAddOnModal_addOnItem__LjfEC {
  margin: 0;
}
.AddAddOnModal_addAddOnModal__zzHuA .AddAddOnModal_addOnButton__VgJP1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px;
  border: 1px solid var(--border-default);
  border-radius: 8px;
  background: var(--white);
  cursor: pointer;
  font: inherit;
  text-align: left;
}
.AddAddOnModal_addAddOnModal__zzHuA .AddAddOnModal_addOnButton__VgJP1:hover {
  background: var(--bg3);
  border-color: var(--border-default);
}
.AddAddOnModal_addAddOnModal__zzHuA .AddAddOnModal_addOnName__4B8gw {
  font: var(--body-font-three);
  color: var(--primary-Text);
}
.AddAddOnModal_addAddOnModal__zzHuA .AddAddOnModal_addOnPrice__pLMox {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
}
.AddAddOnModal_addAddOnModal__zzHuA .AddAddOnModal_noAddOns__kdClG {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  margin: 0 0 16px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Proposal/modal/AddAddOnModal.module.scss"],"names":[],"mappings":"AACC;EACC,4BAAA;EACA,4BAAA;EACA,kBAAA;AAAF;AAEC;EACC,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;AAEC;EACC,SAAA;AAAF;AAEC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,uCAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AAAF;AACE;EACC,sBAAA;EACA,mCAAA;AACH;AAEC;EACC,4BAAA;EACA,0BAAA;AAAF;AAEC;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AAAF;AAEC;EACC,4BAAA;EACA,4BAAA;EACA,kBAAA;AAAF","sourcesContent":[".addAddOnModal {\r\n\t.parentName {\r\n\t\tfont: var(--body-font-three);\r\n\t\tcolor: var(--secondary-Text);\r\n\t\tmargin: 0 0 12px 0;\r\n\t}\r\n\t.addOnList {\r\n\t\tlist-style: none;\r\n\t\tpadding: 0;\r\n\t\tmargin: 0 0 16px 0;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tgap: 8px;\r\n\t}\r\n\t.addOnItem {\r\n\t\tmargin: 0;\r\n\t}\r\n\t.addOnButton {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\twidth: 100%;\r\n\t\tpadding: 12px;\r\n\t\tborder: 1px solid var(--border-default);\r\n\t\tborder-radius: 8px;\r\n\t\tbackground: var(--white);\r\n\t\tcursor: pointer;\r\n\t\tfont: inherit;\r\n\t\ttext-align: left;\r\n\t\t&:hover {\r\n\t\t\tbackground: var(--bg3);\r\n\t\t\tborder-color: var(--border-default);\r\n\t\t}\r\n\t}\r\n\t.addOnName {\r\n\t\tfont: var(--body-font-three);\r\n\t\tcolor: var(--primary-Text);\r\n\t}\r\n\t.addOnPrice {\r\n\t\tfont: var(--body-font-three);\r\n\t\tfont-weight: 600;\r\n\t\tcolor: var(--primary-Text);\r\n\t}\r\n\t.noAddOns {\r\n\t\tfont: var(--body-font-three);\r\n\t\tcolor: var(--secondary-Text);\r\n\t\tmargin: 0 0 16px 0;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addAddOnModal": `AddAddOnModal_addAddOnModal__zzHuA`,
	"parentName": `AddAddOnModal_parentName__ZL1GT`,
	"addOnList": `AddAddOnModal_addOnList__N2-Xe`,
	"addOnItem": `AddAddOnModal_addOnItem__LjfEC`,
	"addOnButton": `AddAddOnModal_addOnButton__VgJP1`,
	"addOnName": `AddAddOnModal_addOnName__4B8gw`,
	"addOnPrice": `AddAddOnModal_addOnPrice__pLMox`,
	"noAddOns": `AddAddOnModal_noAddOns__kdClG`
};
export default ___CSS_LOADER_EXPORT___;
